// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"241":"components__Layouts__layouts","973":"p__QuickAccess__Brand__brand"}[chunkId] + "." + {"241":"1e38efa5","973":"b3a55ab0"}[chunkId] + ".chunk.css";
};